<template>
    <v-navigation-drawer v-if="['A','D'].find(el=>el==store.state.user.groupe)">
        <v-card>
            <v-list-item title="Liste de Commandes" subtitle="Négoce"></v-list-item>
            <v-row >
                <v-checkbox label="Encours"   style="margin-left: 1em;"></v-checkbox>
                <v-checkbox label="Expédié"  ></v-checkbox> 
                <div  class="input-group input-group-sm mb-3" style="margin:20px;">
                    <button style="width: 50px;" @click="getCommandeNegoce(numneg,'test','test')" class="btn btn-outline-secondary" type="button" id="button-addon1">get</button>
                    <!-- <span @click="tab='one';selectArticle(theme.code)" class="input-group-text" id="inputGroup-sizing-sm">{{ theme.code }}</span> -->
                    <input v-model="numneg"  class="form-control form-control-sm" type="text" >
                </div>
            </v-row>
            <!-- <v-row v-if="inProgress">
                <v-checkbox label="ATT" v-model="attente" @change="finished=false;accepted=false;denied=false;getReceptions();" style="margin-left: 1em;"></v-checkbox> 
                <v-checkbox label="OK" v-model="accepted" @change="finished=false;attente=false;denied=false;getReceptions()"></v-checkbox>
                <v-checkbox label="KO" v-model="denied" @change="finished=false;attente=false;accepted=false;getReceptions()"></v-checkbox> 
            </v-row>  -->
            <v-combobox
                clearable
                chips
                multiple
                label="Saison"
                :items="['E24','E25','E26','H24','H25','H26']"
                v-model="filtre.saison"
                variant="outlined"
                density="compact"
                style="margin: 10px"
            ></v-combobox>
            <v-combobox
                clearable
                chips
                multiple
                label="Marque"
                :items="['ETRIER','CAMELEON','WOOMEN']"
                v-model="filtre.marque"
                variant="outlined"
                density="compact"
                style="margin: 10px;margin-top: -20px"
            ></v-combobox>
            <v-text-field
                v-model="filtre.rechercher"
                label="Rechercher"
                variant="outlined"
                density="compact"
                style="margin: 10px;margin-top: -20px"
            ></v-text-field>
            
            <v-list>
                <v-divider></v-divider>
                <v-list-item 
                    v-for="(item, i) in ['NEGO_1','NEGO_2','NEGO_9','NEGO_11','NEGO_12','NEGO_13','NEGO_14','NEGO_15','NEGO_16','NEGO_17','NEGO_18','NEGO_19','NEGO_20']"
                    :key="i"
                    :value="item"
                    color="primary"
                    variant="plain"
                >
                <button type="button" @click="getCommandeNegoce(item.split('_')[1],'test','test')" 
                    class="btn btn-outline-secondary btn-sm" style="width: 200px;">
                    <span>{{ item}}</span><br>
                    <!-- <span v-if="item.reception.informations" :style="[(item.reception.informations.match(/ref/gmi)||item.reception.etat.match(/ref/gmi))?{'color':'red'}:{'color':'green'}]">
                        {{ `${item.reception.informations?''+item.reception.informations:''}`}}
                    </span>  -->
                </button>
                </v-list-item>
            </v-list>
        </v-card> 
    </v-navigation-drawer>
  <!-- <div class="container" width="400" v-if="['A','D','N'].find(el=>el==store.state.user.groupe)"> -->
    
    <div class="container"  width="400" :elevation="10" >
        <v-progress-linear  v-if="store.state.waiting"  color="grey" indeterminate></v-progress-linear>
        <v-card :elevation="10" style="margin-top:5px;margin-bottom:5px">    
            <table  cellspacing="0" cellpadding="5">
                <tbody>
                    <tr >
                        <td style="border: 1;" width="300"><img src="https://www.edisac.com/images/article_la/adint.png" alt=""></td>
                        <td style="border: 1;" width="700" >
                            <h6>AD INTERNATIONAL</h6>
                            <p>Parc d'activité de la verte rue  52 Allée des Prêles</p>
                            <p>59270 Bailleul - FRANCE</p><p>TVA : FR-14-419-363-916</p>
                            <p>Tel : +33 (0)3 28 42 56 94</p>
                        </td>
                        <td style="border: 1;" width="300">
                            <div><h6>Distributeur de la marque</h6>
                                </div>   
                            <div><img src="https://www.edisac.com/images/article_la/etrier_negoce.png" alt="" width="300"></div> 
                        </td>
                    </tr>
                    
                </tbody>
            </table>  
        </v-card>
         <v-card :elevation="10" style="margin-bottom:5px">
            <h4 style="text-align: center;">{{negoce.title.libelle}}</h4>
            <h4 style="text-align: center;">{{ negoce.title.saison }}</h4>
            <h6 style="text-align: center;">{{ negoce.fournisseur.date }}</h6>
        </v-card>
    <!-- <v-card> -->
        
        
    <!-- </v-card> -->
    
    <v-expansion-panels
    >
        
    </v-expansion-panels>
        
    <v-expansion-panels
      v-model="panel"
      :readonly="false"
      multiple
    >
      <v-expansion-panel :elevation="10">
        <v-expansion-panel-title color="#ECECEC">Fourisseur</v-expansion-panel-title>
        <v-expansion-panel-text >
            <v-row>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.date" type="date"  label="DATE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
               
                <v-col cols="12"  md="2">
                    <!-- <v-combobox
                        clearable
                        chips
                        label="CODE CLIENT"
                        :items="itemsClient"
                        v-model="negoce.fournisseur.codeClient"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                    ></v-combobox> -->
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.codeClient" label="CODE CLIENT" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                 <v-col cols="12"  md="3">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.nomClient" label="NOM CLIENT" variant="outlined" density="compact"
                    style="margin: 10px;">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.codeAgent" label="CODE AGENT" variant="outlined" density="compact"
                    style="margin: 10px;">
                </v-text-field>
                </v-col>
                <v-col cols="12"  md="3">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.agent" label="AGENT" variant="outlined" density="compact"
                    style="margin: 10px;">
                </v-text-field>
                </v-col>
               
            </v-row>
            <v-row>
                <v-col cols="12"  md="2">
                    <v-combobox
                        clearable
                        chips
                        label="ETABLISSEMENT"
                        :items="['DEPO','NEGO','RECEP']"
                        v-model="negoce.fournisseur.etablissement"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px;margin-top: -40px"
                    ></v-combobox>
                </v-col>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.libCommande" label="LIB COMMANDE" variant="outlined" density="compact"
                    style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="3">
                    <v-combobox
                        clearable
                        chips
                        label="type commande"
                        :items="['Mise en place','Réassort']"
                        v-model="negoce.fournisseur.type"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px;margin-top: -40px"
                    ></v-combobox>
                </v-col>
                
            </v-row>            
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :elevation="10">
        <v-expansion-panel-title  color="#ECECEC">
            <template v-slot:actions="{ expanded }">
                <v-btn 
                @click.stop="filtreSingleParams.gp_tiers=negoce.fournisseur.codeClient;dialogueFiltreTiers=true"
                variant="tonal"
                size="small"
                class="mr-2"
                icon="mdi-google-analytics"
                >
                </v-btn>
                <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
            </template>
            
            <!-- Contenu du titre -->
            <span>Client</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
             <v-row>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.enseigne" label="ENSEIGNE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.contact" label="CONTACT" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.raisonSociale" label="RAISON SOCIALE" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.email" label="EMAIL" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.telephone" label="TELEPHONE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.tvaSiret" label="TVA OU SIRET" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.dateLivraison" type="date"  label="DATE DE LIVRASION" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                
                <v-col cols="12"  md="5">
                    <v-text-field prepend-inner-icon="mdi-map-marker":disabled="authorized.signe" @change="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseLiv.adresse" label="ADRESSE DE LIVRAISON *" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="5">
                    <v-text-field prepend-inner-icon="mdi-map-marker" :disabled="authorized.signe" @change="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseFac.adresse" label="ADRESSE DE FACTURATION" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
            </v-row>
             <v-row>
                <v-col cols="12"  md="3" style="margin: 10px;margin-top: -40px">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.fournisseur.remarque" label="CONSIGNES / REMARQUES" variant="outlined" density="compact"
                        >
                    </v-text-field>
                </v-col>
                 <!-- <v-col cols="12"  md="8" style="margin: 10px;margin-top: -40px">
                    <v-btn :disabled="authorized.modif" v-model="negoce.client.siteweb" label="SITE INTERNET" 
                        >{{negoce.client.siteweb}}
                    </v-btn>
                </v-col> -->
                <!-- <v-col cols="12"  md="1" style="margin: 10px;margin-top: -40px">
                    <v-btn :disabled="authorized.modif" @click="getStatsTiers('rechercherNegoces',negoce.fournisseur.codeClient)"
                        >Stats
                    </v-btn>
                </v-col>  -->
            </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :elevation="10">
        <v-expansion-panel-title color="#ECECEC">Articles</v-expansion-panel-title>
        <v-expansion-panel-text >
        <div   style="overflow-y: auto;max-height: 900px;;min-height: 300px;">
            <div style="position: sticky;top: 0;z-index: 2">
                <table  style="border: 0.1em  solid">
                    <thead >
                        <tr >   
                            <th width="100" style="border: 0.1em  solid">theme</th> 
                            <th width="100" style="border: 0.1em  solid;">Réf.</th>
                            <th width="100" style="border: 0.1em  solid;">Dés.</th>
                            <th width="100" style="border: 0.1em  solid;">couleur</th>
                            <th width="100" style="border: 0.1em  solid;">taille</th>
                            <th width="100" style="border: 0.1em  solid;" @click="rechercherArticleStatut={statut:false,msg:''};rechercherArticle='';dialogaAjout=true;tab='art'" class="iconAdd"><v-icon class="iconAdd" icon="mdi-store-search" ></v-icon></th>
                            <th width="100" style="border: 0.1em  solid;">Statut</th>
                            <th width="100" style="border: 0.1em  solid;"></th>
                            <th width="100" style="border: 0.1em  solid;">Qte</th>
                            <th width="100" style="border: 0.1em  solid;">Prix Négoce</th>
                            <th width="100" style="border: 0.1em  solid;">Prix TTC </th>
                            <th width="100" style="border: 0.1em  solid;">Totale</th>
                        </tr>
                    </thead>
                </table>
            </div>
           <div  v-for="theme in negoce.articles"><span><v-icon class="iconAdd" icon="mdi-plus" @click="dialogaAjout=true;selectArticle()"></v-icon></span>
            {{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme}}
            
                <div  v-for="refs in theme" >
                    <table  >
                        <tbody style="border: 0.1em  solid;">
                            <tr >
                                <th width="100" rowspan="30" valign="top">
                                    <img style="border: 1px solid grey;padding: 1px;" @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`" v-if="refs[Object.keys(refs)[0]].imagename" :src="`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`"  width="100px" height="70px">
                                </th>
                                <th width="100" :disabled="authorized.modif"><v-icon @click="dialogaAjout=true;selectArticle(refs[Object.keys(refs)[0]].code_theme)" v-if="refs[Object.keys(refs)[0]].reference_y2==theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].reference_y2" class="iconAdd" icon="mdi-plus" ></v-icon><span @dblclick="deleteDialog=true;articleToDelete={type:'ref',art:refs[Object.keys(refs)[0]]}">{{ refs[Object.keys(refs)[0]].reference_y2 }}</span></th>
                                <th width="100" >{{ refs[Object.keys(refs)[0]].designation }}</th>
                                <th width="100" :disabled="authorized.modif" class="iconAdd"><v-icon class="iconAdd" icon="mdi-plus" @click="dialogaAjout=true;selectArticle(refs[Object.keys(refs)[0]].code_theme,refs[Object.keys(refs)[0]].reference_y2)"></v-icon></th>
                                <th colspan="8" ></th>
                            </tr>
                            <tr v-for="article in refs">
                                <td width="100" ></td>
                                <td width="100" ></td>
                                <td width="100"  ><span @dblclick="deleteDialog=true;articleToDelete={type:'color',art:article}">{{`${article.code_couleur}-${article.couleur}`}}</span></td>
                                <td width="100"  >{{article.taille}}</td>
                                <td width="100" ></td>
                                <td width="100" ><v-icon :icon="etatStock(article).icon" size="small" :color="etatStock(article).color"></v-icon></td>
                                <td width="100" ></td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.signe" min="0" size="6" style="width: 90%;" type="number" v-model="article.qte"></td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.modif" min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_negoce"><span >€</span></td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.modif" min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_euro"><span >€</span></td>
                                <td width="100" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" :value="(article.vte_negoce*article.qte).toFixed(2)" disabled><span > €</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            <div>
                <table>
                    <tbody style="border: 0.1em  solid;">
                        <tr>
                            <td width="700"></td>
                            <th width="100" style="text-align: right; ">Sous Totale</th>
                            <th width="100">{{totaleQteCde(theme)}}</th>
                            <th width="200"></th>
                            <th width="100" ><input size="6" type="text" style="width: 70px;" disabled :value="totaleHtCde(theme)"><span >€</span></th>
                        </tr>
                    </tbody>
                </table>
            </div>  
           </div>
             </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody style="border: 0.1em  solid;">
                        <tr>
                            <td width="100px" rowspan="5" colspan="6" style="border: 0.1em  solid;max-height:200px ;" class="chart-container">
                                <Pie   :data="chartData" :options="chartOptions" />
                            </td>
                            <td colspan="6" height="20">  </td> 
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px">TOTAL QUANTITES :</th>
                            <th width="100px">{{ totaleHtCde2(negoce.articles).qte}}</th>
                            <th width="100px" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100px">
                                <input min="0" :disabled="authorized.modif" disabled size="6" style="width: 70px;" type="number" :value="totaleHtCde2(negoce.articles).totale"><span >   €</span>
                            </th>
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px"></th>
                            <th width="100px"></th>
                            <th width="200px" style="text-align: right; ">FRAIS DE PORT:</th>
                            <th width="100px" >
                                <input min="0"  size="6" style="width: 70px;" type="number" v-model="negoce.fraisPort">€
                            </th>
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px" ></th>
                            <th width="100px" ></th>
                            <th width="100px" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100px" ><input min="0" disabled size="6" style="width: 70px;" type="number" :value="Number(totaleHtCde2(negoce.articles).totale)+negoce.fraisPort"><span >   €</span></th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600px" style="text-align: center ;border: 0.1em  solid;">CONDITIONS COMMERCIALES NEGOCE - 2026 France métropolitaine (hors Corse) et Belgique <a href='https://www.edisac.com/second-life-cgv-t16037/' target="_blank">voir</a></td>
                            <td width="100px"></td>
                            <td width="500px"  >Je reconnais avoir reçu et pris connaissance des CONDITIONS GENERALES DE VENTE </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                         <tr>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"   > </td>
                            <td width="100px"   > </td>
                            <td width="100px"   > </td>
                            <td  width="500px"  rowspan="3">
                                <v-card :elevation="10" v-if="negoce.signature.exist" >
                                    <v-card v-if="negoce.signature.exist"  >
                                        <img :src="negoce.signature.link" ></img>
                                    </v-card>
                                </v-card>
                                <v-card :elevation="10" v-if="!negoce.signature.exist">
                                    <Vue3Signature   :disabled="store.state.user.groupe!='N'"  ref="signature1" :sigOption="state.option" :w="'500px'" :h="'100px'">
                                    </Vue3Signature>
                                </v-card>
                            </td>
                        </tr> 
                        <tr>
                            <td width="100px" height="20" style="border: 0.1em  solid;" >coef 2.8</td>
                            <td width="100px" style="border: 0.1em  solid;" >MIN COMMANDE MEP</td>
                            <td width="100px" style="border: 0.1em  solid;" >FRANCO MEP</td>
                            <td width="100px" style="border: 0.1em  solid;" >MIN REA</td>
                            <td width="100px" style="border: 0.1em  solid;" >FRANCO REA</td>
                            <td width="100px" style="border: 0.1em  solid;" >PORT</td>
                            <td width="100px"> </td>
                        </tr>
                        <tr>
                            <td width="100px" height="20" style="border: 0.1em  solid;" >MAROQUINERIES</td>
                            <td width="100px" style="border: 0.1em  solid;" >500 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >1000 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >20 € HT</td>
                            <td width="100px"> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-bottom: 20px;">
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600px"></td>
                            <td width="100px"></td>
                            <td width="500px" >
                                <v-bottom-sheet  inset>
                                    <template v-slot:activator="{ props: activatorProps }">
                                        <v-btn v-if="!negoce.signature.exist&&store.state.user.groupe=='N'"  style="margin: px;" v-bind="activatorProps" @click="save('./image.jpeg')" text="Signer"></v-btn>
                                    </template>
                                    <v-card
                                        title="Signature"
                                        text="Votre signature a été pris en compte!"
                                    ></v-card>
                                </v-bottom-sheet>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        <v-card v-if="store.state.user.groupe=='A'" class="actions-card">
            <v-card-actions class="justify-center">
                <v-btn color="success" size="large"  
                    :disabled="store.state.user.groupe=='N'"
                    :loading="loading" 
                    @click="authentification=true" 
                >
                <v-icon icon="mdi-check" class="mr-2"></v-icon>
                    Valider la Commande
                </v-btn>
                <v-btn v-if="store.state.user.groupe!='N'" @click="nouvelleCommande()" color="warning">
                    <v-icon icon="mdi-autorenew" class="mr-2"></v-icon>
                    Nouvelle Commande</v-btn>
                <v-btn @click="EnvoyerCommandeNegoce()" color="primary">
                    <v-icon icon="mdi-email" class="mr-2"></v-icon>
                    Envoyer</v-btn>
            </v-card-actions>
        </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-if="!authorized.modif" class="text-center" >
      <v-dialog  v-model="dialogaAjout" width="auto" >
        <v-card  prepend-icon="mdi-plus" 
        :text="tab=='art'?`Veulliez saisir l'article à ajouter`:(tab=='three'?`Veulliez choisir le thème à ajouter`:(tab=='two'?`Veulliez choisir la référence à ajouter`:`Veuillez saisir la qté de chaque couleur`))"
        title="Ajout Articles"
        >
        <v-card >
            <v-card-text >
            <div v-if="tab=='art'" class="input-group input-group-sm mb-3">
                <input size="5"  v-model="rechercherArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
            </div>
            <div v-if="tab!='art'" class="input-group input-group-sm mb-3" height="10px">
                <input size="5"  v-model="rechercher"  class="form-control form-control-sm" type="text" >
                <div v-if="tab=='one'">
                    <input v-model="EAN13Choice" style="margin: 0.4rem;" type="checkbox" id="scales" name="scales" checked />
                    <label style="font:1rem Fira Sans,sans-serif;" for="scales">ean13</label>
                </div>
            </div>
            <div v-if="rechercherArticleStatut.statut" style="text-align: center;color: red;">
                <p>{{ rechercherArticleStatut.msg }}</p>
            </div>
            <v-tabs-window v-model="tab" >
                <v-tabs-window-item value="one">
                    <v-card class="scroll-box">  
                        <table height="auto">
                            <tbody>
                                <tr v-for="color in articleToAddTabFilter" >
                                    <td  >
                                        
                                        <div class="input-group input-group-sm mb-3">
                                            <button style="width: 150px;" @click="color.qte++" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ `${color.taille?color.code_couleur+"-"+color.couleur+"-"+color.taille:color.code_couleur+"-"+color.couleur}` }}</button>
                                            <input  v-if="EAN13Choice" :style="[gererateEAN13(color.ean13_y2).erreur?{'color':'red','width': '120px'}:{'color':'green','width': '120px'}]" v-model="color.ean13_y2"  class="form-control form-control-sm" type="text" ></input>
                                            <input  style="width: 70px;" v-model="color.qte"  min="0" class="form-control form-control-sm" type="number" ></input>
                                            <span ><v-icon style="margin-top: 8px;margin-left: 8px;" :icon="etatStock(color).icon" size="small" :color="etatStock(color).color"></v-icon></span>
                                            
                                        </div>
                                        <p  v-if="EAN13Choice&&gererateEAN13(color.ean13_y2).erreur" style="color:red;height: 2px;text-align: center;">Vérifiez le code ean13</p>    
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card>   
                </v-tabs-window-item>
                <v-tabs-window-item value="two" scrollable>
                   <v-card class="scroll-box">
                    <table height="auto">
                        <tbody>
                            <tr v-for="ref in articleToAddTabFilter">
                                <td  width="300" >
                                    
                                    <div class="input-group input-group-sm mb-3">
                                        <button style="width: 150px;" @click="tab='one';selectArticle(ref.theme,ref.code )" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ ref.code  }}</button>
                                        <input disabled v-model="ref.libelle"  class="form-control form-control-sm" type="text" >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="three" height="400">
                    <v-card class="scroll-box">
                        <div v-for="theme in articleToAddTabFilter" style="margin-top: 1px;">
                            <div  class="input-group input-group-sm mb-3">
                                <button style="width: 150px;" @click="tab='one';selectArticle(theme.code)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ theme.code  }}</button>
                                <input disabled="true" v-model="theme.libelle"  class="form-control form-control-sm" type="text" >
                            </div>
                        </div>
                    </v-card>
                </v-tabs-window-item>
            </v-tabs-window>
            </v-card-text>
        </v-card>
        <template v-slot:actions>
            <v-btn class="ms-auto" text="Annuler" @click="dialogaAjout = false" style="text-align: left;"></v-btn>
            <v-btn v-if="tab!='art'" class="ms-auto" text="Ajouter" @click="addArticle();dialogaAjout = false"></v-btn>
            <v-btn v-if="tab=='art'" class="ms-auto" text="Ajouter" @click="getArticle()"></v-btn>
        </template>
        </v-card>
      </v-dialog>
    </div> 
    <div class="text-center pa-4">
      <v-dialog
        v-model="deleteDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="$error"
          :text="`${articleToDelete.type=='color'?'Vous voulez vraiment supprimer la couleur '+articleToDelete.art.couleur+' ?':'Vous voulez vraiment supprimer la référence '+articleToDelete.art.reference_y2+' ?'}`"
          title="Suppression"
        >
          <template v-slot:actions>
            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="deleteDialog = false"
                    variant="plain"
                    color="green"
                ></v-btn>
                <v-btn
                    color="red"
                    text="Supprimer"
                    @click="supprimer();deleteDialog = false"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="commandeNotExist.exist"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="$error"
          :text="commandeNotExist.new=='rien'?`La commande numéro ${commandeNotExist.numero} n'existe pas`:(commandeNotExist.new=='new'?`La commande numéro ${commandeNotExist.numero} a été créé`:`La commande numéro ${commandeNotExist.numero} a été importé`)"
          title="Commande pas trouvé"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="commandeNotExist.exist = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
        <v-dialog
            v-model="dialogEmail"
            width="auto"
        >
            <v-card
            max-width="400"
            prepend-icon="mdi-update"
            :text="`La commande a été renvoyé`"
            title="Email envoyé"
            >
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogEmail = false"
                ></v-btn>
            </template>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="authentification"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="mdi-account-check"
          text="Veuillez saisir votre mot de passe"
          title="Vérification"
          >
          <v-spacer></v-spacer>
          <v-card-actions >
            <input 
            type="text" class="form-control" placeholder="mot de passe" aria-label="mot de passe" aria-describedby="basic-addon2" v-model="mdpSaisie">
            <v-btn
            text="Annuler"
            @click="authentification = false"
            color="warning"
            ></v-btn>
            <v-btn
            text="Valider"
            @click="checkingLogIn()"
            :disabled="mdpSaisie!=''?false:true"
            color="success"
            ></v-btn>
            
            </v-card-actions>
            <small v-if="message" style="color:red;margin-left: 0.5em;text-align: center;" >{{message}}</small>
          </v-card>
      </v-dialog>
    </div>
    <div  >
        <v-dialog
            v-model="dialogAdresse.statut"
            :persistent="dialogAdresse.persistent"
           max-width="600px" 
        >
            <v-card
            title="Adresse"
            >
                <v-card-text>
                    <v-row>
                        <v-col cols="12"  md="6">
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].libelleAdresse" label="Libelle" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].adresse1" label="Adresse 1" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].adresse2" label="Adresse 2" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].codePostal" label="Code Postal" variant="outlined"></v-text-field>
                        </v-col> 
                        <v-col>
                            <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].ville" label="Ville" variant="outlined"></v-text-field>
                        </v-col> 
                        <v-col>
                            <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].pays" label="Pays" variant="outlined"></v-text-field>
                        </v-col> 
                    </v-row>
                </v-card-text>
                <v-spacer></v-spacer>
            <v-card-actions >
                <v-btn
                    text="Annuler"
                    @click="dialogAdresse.persistent?changeAdresse():dialogAdresse.statut = false"
                    color="warning"
                ></v-btn>
                <v-btn
                    text="Valider"
                    @click="changeAdresse()"
                    color="success"
                ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>  
    <v-dialog
        v-model="dialogStatsTiers"
        width="auto"
        persistent
    >
        <v-card
        prepend-icon="'mdi-google-analytics"
        :title="`${statsTable[0].gp_tiers? 'Statistiques Client : '+statsTable[0].gp_tiers:'Veuillez patienter'}` "
        >
        <v-card-text>
            <div width="900px">
                <table>
                    <tbody>
                        <tr>
                            <!-- <v-btn density="compact" @click="statsToGet='all';dialogueFiltre=true" icon="mdi-plus" style="margin-top: 15px;" ></v-btn> -->
                            <td width="150px">
                                <v-select  
                                variant="outlined"
                                :items="['gl_naturepieceg','gl_etablissement','numero','gp_tiers','code_commercial','marque','theme','rayon','famille','sousfamille','ga_codearticle','couleur','codebarre','gp_librepiece1','gp_librepiece3','gl_collection','annee']"
                                density="compact"
                                label="Axe X"
                                v-model="axe.x"
                                ></v-select>
                            </td>
                            <td width="150px" style="margin-left: 10px;">
                                <v-select
                                    variant="outlined"
                                    :items="['gl_qtestock','gl_totalht']"
                                    density="compact"
                                    label="Axe Y"
                                    v-model="axe.y"
                                ></v-select>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                            </td>
                            
                            <td width="160px" style="margin-left: 10px;"> 
                                <v-text-field :disabled="authorized.modif" density="compact" v-model="filtreSingleParams.gp_tiers" label="Code Client" type="text" variant="outlined" clearable></v-text-field>
                            </td>
                            <td width="160px" style="margin-left:10px;">
                                <v-combobox clearable    chips    multiple
                                    label="Saison"
                                    :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                    v-model="filtreSingleParams.gp_librepiece3"
                                    variant="outlined" density="compact"
                                ></v-combobox>
                            </td>
                           
                            <v-btn style="margin-top: 15px;margin-left: 10px;"
                                density="compact"
                                :loading="loading"
                                :disabled="!filtreSingleParams.gp_tiers&&!filtreSingleParams.gp_librepiece3"
                                @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                                aria-label="Refresh"
                                icon="mdi-refresh"
                            ></v-btn>
                            <v-btn  density="compact" style="margin-top: 15px;;margin-left: 10px;" color="green" @click="exportToExcel(statsTable)" >
                                <v-icon icon="mdi-file-excel"></v-icon>
                            </v-btn>
                            <!-- </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div   class="chart-chart-container-pie">
                <div v-if="!dialogErreur" style="height: 400px">
                    <Pie  v-if="!isBarChart" :data="chartDataStats" :options="pieOptions" />
                    <Bar  v-if="isBarChart" :data="chartDataStats" :options="barOptions" />
                </div>
                <div v-if="dialogErreur" class="loading-content" width="400px">
                    <p class="mt-4 text-h6">Pas de données...</p>
                    <p class="text-caption">Modifier le filtre</p>
                    <!-- <template v-slot:actions> -->
                
                    <!-- </template> -->
                </div>
            </div>
        </v-card-text>
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogStatsTiers = false"
                ></v-btn>
            </template>
        </v-card>
    </v-dialog>
    <div  class="text-center" >
        <!-- max-width="600" width="600" -->
        <v-dialog v-model="dialogueFiltreTiers" width="600"  :persistent="loading">
            <v-card  prepend-icon="mdi-shopping-search" 
            text="Veillez changer les dates"
            title="Filtrage"
            >
        
            <v-card-text >
                    <v-row  style="margin-top: 10px">
                        <v-col cols="12" md="4" sm="12">
                            <v-text-field :disabled="authorized.modif" clearable type="text" label="Code Client" style="margin-top: -40px" v-model="filtreSingleParams.gp_tiers" variant="outlined" density="compact"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-text-field clearable type="text" label="Commercial" style="margin-top: -40px" v-model="filtreSingleParams.code_commercial" variant="outlined" density="compact"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                             <v-combobox clearable    chips    multiple
                                label="Marque"
                                :items="['ETRIER','WOOMEN','CAMELEON']"
                                v-model="filtreSingleParams.marque"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                    </v-row>  
                    <v-row>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips    multiple
                                label="Nature"
                                :items="['CC - Commande','BLC - Livraison','AVS - Avoir Stock','AVC - Avoir Client']"
                                v-model="filtreSingleParams.gl_naturepieceg"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips
                                label="Type"
                                :items="['CATSTD','CATREA']"
                                v-model="filtreSingleParams.gp_librepiece1"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips    multiple
                                label="Saison"
                                :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                v-model="filtreSingleParams.gp_librepiece3"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                     
                </v-card-text>
                <v-card-actions>
                    <div class="d-flex justify-space-between w-100">
                        <v-btn 
                            text="Annuler"
                            @click="loading=false;dialogueFiltreTiers=false"
                            color="warning"
                        ></v-btn>
                        <v-btn 
                            text="Lancer la recherche"
                            :loading="loading"
                            :disabled="loading"
                            @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                            color="primary"
                        ></v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>
<script setup>
    import { reactive, onMounted, ref, computed, watch } from 'vue'
    import axios from 'axios'
    import store from './store'
    import router from './router'
    import * as XLSX from 'xlsx';
    import {
    Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale 
    } from 'chart.js'
    import { Pie, Bar } from 'vue-chartjs'
    import { useRoute, onBeforeRouteUpdate } from 'vue-router'
    let deleteDialog=ref(false)
    let srcImage=ref()
    let imageDialog=ref(false)
    const zoom = ref(600)
    let loading = ref(false)
    let dialogStatsTiers=ref(false)
    let authentification=ref(false)
    const isBarChart = ref(false)
    let dialogueFiltreTiers=ref(false)
    let filtre=ref({
        saison:null,
        marque:null,
        rechercher:null
    })
    let axe=ref({
        x:'gp_librepiece3',
        y:'gl_qtestock',
        showPercent:false
    })
    let filtreSingleParams=ref({
        gp_tiers : null,
        gl_naturepieceg : null,
        code_commercial: null,
        gp_librepiece1 : null,
        gp_librepiece3 : null,
        date_debut : null,
        date_fin : null,
        date_liv_debut : null,
        date_liv_fin : null,
        marque : null,
        rayon : null,
        acheteur : null,
        codepole : null,
        limit : null,
        offset : 0
    })
    let commandeNotExist=ref({exist:false,numero:''})
    let EAN13Choice=ref(false)
    let typeAdressToChange=ref('')
    function changeAdresse(){
        negoce.value.client[typeAdressToChange.value].adresse=`${negoce.value.client[typeAdressToChange.value].adresse1} - ${negoce.value.client[typeAdressToChange.value].codePostal} - ${negoce.value.client[typeAdressToChange.value].ville} - ${negoce.value.client[typeAdressToChange.value].pays}`
        dialogAdresse.value.statut = false
    }
    const route = useRoute()
    const id = ref(null)
    const num = ref(null)
    const token = ref(null)
    const currentUrl = ref('')
    const error = ref('')
    let message=ref()
    let dialogEmail=ref(false)
    let mdpSaisie=ref('')
    let dialogErreur=ref(false)
    defineProps({
        id: String,
        num: [String, Number],
        token: String,
    })
    const loadParams = () => {
        // console.log(route.params);
        if(route.params.id&&route.params.num){
            try {
                id.value = route.params.id
                num.value = route.params.num
                token.value = route.params.token
                currentUrl.value = window.location.href
                
                // console.log('Params reçus:', { id: id.value, num: num.value, token:token.value })
                // if(router.currentRoute.value.params.id&&router.currentRoute.value.params.num){
                    store.commit('addUser',{groupe:'N'})
                    getCommandeNegoce (num.value,id.value,token.value)
                // }
                if (!id.value || !num.value || !token.value) {
                error.value = 'Paramètres manquants'
                }
            } catch (err) {
                error.value = err.message
            }
        }
    }
    let dialogAdresse=ref({
        statut:false
    })
        //
    let negoce=ref({
        title:{
            libelle:'BON DE COMMANDE',
            saison:'SPRING - SUMMER 2026',
            dateModif:'2025-09-25'
        },
        fournisseur:{
            date:'2025-10-01',
            nomClient:'Test',
            codeClient:'RE97SAC763',
            agent:'agent_test',
            codeAgent:'code_agent',
            libCommande:'testcommande',
            etablissement:'NEGO',
            type:'MEP'
        },
        client:{
            enseigne:'enseigne',
            raisonSociale:'test',
            tvaSiret:'TVA_TEST',
            dateLivraison:'2025-10-15',
            adresseLiv:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'adresse Liv',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            adresseFac:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'adresse fact',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            contact:'contact_test',
            email:'emailtest',
            telephone:'0769',
            siteweb:'site',
            remarque:'Remarque'
        },
        fraisPort:20,
        articles:{
            'ET90':
            {
                '080-0EMAD013':{
                    '1000005926069':
                    {
                        reference_y2:'080-0EMAD013',
                        codebarre:'1000005926069',
                        code_couleur:'01',
                        couleur:'Noir',
                        codebarre:'3663779244609',
                        ean13_y2:'',code_theme:'ET90',
                        theme:'MADRAS',
                        marque:'etrier',
                        designation:'Porte-cartes',
                        vte_euro:59,
                        vte_negoce:25,
                        qte:0
                    }
                }
            }
        },
        signature:{exist:false,link:'',file:''}

    })
    function nouvelleCommande(){
        negoce.value={
        title:{
            libelle:'BON DE COMMANDE',
            saison:'SPRING - SUMMER 2026',
            dateModif:'2025-09-25'
        },
        fournisseur:{
            date:'2025-10-01',
            nomClient:'Test',
            codeClient:'code_test',
            agent:'agent_test',
            codeAgent:'code_agent',
            libCommande:'testcommande',
            etablissement:'NEGO'
        },
        client:{
            enseigne:'enseigne',
            raisonSociale:'test',
            tvaSiret:'TVA_TEST',
            dateLivraison:'2025-10-15',
            adresseLiv:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'test',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            adresseFac:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'adresse Fact',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            contact:'contact_test',
            email:'emailtest',
            telephone:'0769',
            siteweb:'site',
            remarque:'Remarque'
        },
        fraisPort:20,
        articles:{
            'ET90':
            {
                '080-0EMAD013':{
                    '1000005926069':
                    {
                        reference_y2:'080-0EMAD013',
                        codebarre:'1000005926069',
                        code_couleur:'01',
                        couleur:'Noir',
                        codebarre:'3663779244609',
                        ean13_y2:'',code_theme:'ET90',
                        theme:'MADRAS',
                        marque:'etrier',
                        designation:'Porte-cartes',
                        vte_euro:59,
                        vte_negoce:25,
                        qte:0
                    }
                }
            }
        },
        signature:{exist:false,link:'',file:''}
        }
    }
    const state = reactive({
        count: 0,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255,255,255)"
            },
            disabled: false
        })
    // Enregistrer les composants de Chart.js nécessaires
    // ChartJS.register(Title, Tooltip, Legend, ArcElement)
    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )
    // Données du graphique
    
    const chartData = computed(() => ({
        labels: chartData1().tabTheme,
        datasets: [
            {
                label: 'Usage',
                backgroundColor: chartData1().colorTab,
                data: chartData1().tabQte,
            },
        ],
    }))
    const chartDataStats = computed(() => {
            const data = chartData2()
            return {
                labels: data.tabTheme,
                datasets: [{
                label: `Données ${axe.value.showPercent?'% ':''}`,
                data: data.tabQte,
                backgroundColor: data.colorTab
                }]
            }
        })

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'right' }
        }
    }

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: { beginAtZero: true }
        }
    }
    let statsTable=ref([])
    function chartData2() {
        const qte = { autre: 0 };
        const colorTab = [generateRandomColor()];
        let sum = 0;
        
        const data = getDataSource();
        // const { axe.value.x, axe.value.y, showPercent } = axe.value;
        // axe.value.x, axe.value.y, showPercent
        // console.log({ axe.value.x, axe.value.y, showPercent } );
        
        // Traitement unique
        Object.values(data).forEach(item => {
            if (!item || item[axe.value.x] === undefined) return;
            if(item[axe.value.x] ){
                const xVal = item[axe.value.x].toString();
                const yVal = Number(item[axe.value.y]) || 0;
                
                if (!xVal) {
                    qte.autre += yVal;
                } else {
                    if (!qte[xVal]) {
                        colorTab.push(generateRandomColor());
                        qte[xVal] = yVal;
                    } else {
                        qte[xVal] += yVal;
                    }
                }
                sum += yVal;
            }
            
        });
        
        // Nettoyage et retour
        if (qte.autre === 0) {
            delete qte.autre;
            colorTab.shift();
        }
        
        const tabTheme = Object.keys(qte);
        let tabQte = Object.values(qte);
        
        if (axe.value.showPercent) {
            const factor = 100 / sum;
            tabQte = tabQte.map(value => value * factor);
        }
        // console.log({ tabTheme, colorTab, tabQte });
        
        return { tabTheme, colorTab, tabQte };
        
        function getDataSource() {
            return grapheType.value === 'tiers' 
                ? tiersTable.value
                : axe.value.source === 'GLOBAL'
                    ? statsTable.value
                    : statsTableFiltred.value;
        }
        
        function generateRandomColor() {
            return '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16).padStart(6, '0');
        }
    } 
    
    watch(
        axe,
        (newValue, oldValue) => {
            chartData2()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    let readyToExport=ref(true)
    watch(
        filtreSingleParams,
        (newValue, oldValue) => {
            readyToExport.value=false
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    // Options du graphique
    const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    
    } 
    const signature1 = ref(null)
    let authorized=computed(()=>{
        return {
           modif: store.state.user.groupe=='N'?true:false,
           signe: store.state.user.groupe=='N'&&negoce.value.signature.exist?true:false

        }
        // return  store.state.user.groupe=='N'?true:false
    })
    ref(false)
    let tab=ref()
    let dialogaAjout=ref(false)
    const panel = ref([ 2])
    const readonly = ref(false)
    let rechercherArticle=ref()
    let rechercherArticleStatut=ref({statut:false,msg:''})
    function getArticle(){
        for (let theme in store.state.articles[731]){
            for(let ref in store.state.articles[731][theme]){
                if(ref==rechercherArticle.value){
                    selectArticle(theme,ref)
                    rechercherArticle.value=''
                    rechercherArticleStatut.value={statut:false}
                    return
                }
                for(let cab in store.state.articles[731][theme][ref]){
                    if(cab==rechercherArticle.value || rechercherArticle.value==store.state.articles[731][theme][ref][cab].ean13_y2){                    
                        articleToAdd.value={[cab]:
                            {
                            ...store.state.articles['731'][theme][ref][cab],qte:1
                            }
                        }
                        addArticle()
                        dialogaAjout.value=false
                        rechercherArticle.value=''
                        rechercherArticleStatut.value={statut:false}
                        return
                    }
                }
            }
        }
        rechercherArticleStatut.value={statut:true,msg:"L'article n'existe pas!"}
    }
  
    let articleToAdd=ref()
    // function ajoutClient(){
    //     negoce.value.fournisseur.codeClient=negoce.value.fournisseur.codeClient.split('-')[0].trim()
    //     let clientSelected=tiersTable.find(cl=>cl.t_tiers==negoce.value.fournisseur.codeClient)
    //     // negoce.value.client={
    //     // negoce.value.client.enseigne:'enseigne',
    //     negoce.value.client.raisonSociale=clientSelected.t_prenom
    //     negoce.value.client.tvaSiret=clientSelected.t_siret
    //     negoce.value.client.adresseLiv={
    //         adresse:'30 rue national - 59270 - Bailleul - France' `${clientSelected.t_adress1} - ${clientSelected.t_codepostal} - `,
    //         libelleAdresse:'test',
    //         adresse1: '30 rue national',
    //         adresse2: 'test',
    //         codePostal: '59270',
    //         ville: 'Bailleul',
    //         pays: 'France'
    //     }
    //     negoce.value.client.adresseFac={
    //         adresse:'30 rue national - 59270 - Bailleul - France',
    //         libelleAdresse:'adresse Fact',
    //         adresse1: '30 rue national',
    //         adresse2: 'test',
    //         codePostal: '59270',
    //         ville: 'Bailleul',
    //         pays: 'France'
    //     },
    //     negoce.value.client.contact='contact_test'
    //     negoce.value.client.email='emailtest'
    //     negoce.value.client.telephone='0769'
    //     negoce.value.client.siteweb='site'
    //     negoce.value.client.remarque='Remarque'
    // }
    // watch(
    //     () => negoce.value.fournisseur.codeClient,
    //     (newStatut, oldStatut) => {
    //         negoce.value.fournisseur.codeClient=negoce.value.fournisseur.codeClient.split('-')[0].trim()
    //         let clientSelected=tiersTable.find(cl=>cl.t_tiers==negoce.value.fournisseur.codeClient.split('-')[0].trim())
    //         negoce.value.client={
    //         enseigne:'enseigne',
    //         raisonSociale:'test',
    //         tvaSiret:'TVA_TEST',
    //         dateLivraison:'2025-10-15',
    //         adresseLiv:{
    //             adresse:'30 rue national - 59270 - Bailleul - France',
    //             libelleAdresse:'test',
    //             adresse1: '30 rue national',
    //             adresse2: 'test',
    //             codePostal: '59270',
    //             ville: 'Bailleul',
    //             pays: 'France'
    //         },
    //         adresseFac:{
    //             adresse:'30 rue national - 59270 - Bailleul - France',
    //             libelleAdresse:'adresse Fact',
    //             adresse1: '30 rue national',
    //             adresse2: 'test',
    //             codePostal: '59270',
    //             ville: 'Bailleul',
    //             pays: 'France'
    //         },
    //         contact:'contact_test',
    //         email:'emailtest',
    //         telephone:'0769',
    //         siteweb:'site',
    //         remarque:'Remarque'
    //        }
    //     },
    //     { deep: false } // deep: false car on ne watch qu'une propriété primitive
    // );
    function addArticle(){
      for(let art in articleToAdd.value){
        if(articleToAdd.value[art].qte){
            if(!negoce.value.articles[articleToAdd.value[art].code_theme]){
                negoce.value.articles={
                    ...negoce.value.articles,
                    [articleToAdd.value[art].code_theme]: negoce.value.articles[articleToAdd.value[art].code_theme]=
                    {...negoce.value.articles[articleToAdd.value[art].code_theme],
                        [articleToAdd.value[art].reference_y2]:{
                            [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                        }
                    }
                }
                
            }
            else if(!negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]){               
                negoce.value.articles[articleToAdd.value[art].code_theme]=
                {...negoce.value.articles[articleToAdd.value[art].code_theme],
                    [articleToAdd.value[art].reference_y2]:{
                        [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                    }
                }
            }else if(!negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2][articleToAdd.value[art].codebarre]){             
                negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]=
                {...negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2],
                    [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                }
            }
        }
      }
    }
    let articleToAddTab=ref([])
    function etatStock(article){
        if(article.stock){
            if(article.stock.NEGO&&article.stock.NEGO>=30){
                return {icon:"$success",color:"success"}
            }else if(article.stock.NEGO&&article.stock.NEGO>=10){
                return {icon:"$info",color:"primary"}
            }else if(article.stock.NEGO&&article.stock.NEGO>=3){
                return {icon:"$info",color:"warning"}
            }else{
                return {icon:"$error",color:"error"}
            }
            
        }else{
            return {icon:"mdi-delete-forever",color:"error"}
        }
        
    }
    function gererateEAN13(cab){

        let ean=Number(cab)
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()!=cab&&cab!=''?{erreur:true,color:'red'}: {erreur:false}
    }
      let rules=(value)=>{
        if (value){
            return [true]
        } else{
            return [`Le ean13 n'est pas en bon format`]
        }
        
    }
    function selectArticle(theme,codeArticle){
        
        
        rechercher.value=''
        rechercherArticleStatut=ref({statut:false,msg:''})
        if(codeArticle){
            articleToAddTab.value=[]

            tab.value="one"
            for(let art in store.state.articles['731'][theme][codeArticle]){
                if(!negoce.value.articles[theme]){
                    store.state.articles['731'][theme][codeArticle][art]={
                        ...store.state.articles['731'][theme][codeArticle][art],qte:0
                        }
                        articleToAddTab.value.push(store.state.articles['731'][theme][codeArticle][art])
                }else{
                    if(!negoce.value.articles[theme][codeArticle]){
                    store.state.articles['731'][theme][codeArticle][art]={
                        ...store.state.articles['731'][theme][codeArticle][art],qte:0
                        }
                        articleToAddTab.value.push(store.state.articles['731'][theme][codeArticle][art])
                    }else{
                        if(!negoce.value.articles[theme][codeArticle][art]){
                            store.state.articles['731'][theme][codeArticle][art]={
                            ...store.state.articles['731'][theme][codeArticle][art],qte:0
                            }
                            articleToAddTab.value.push(store.state.articles['731'][theme][codeArticle][art])
                        }  
                    }
                }
                
                
            }
            articleToAdd.value= store.state.articles['731'][theme][codeArticle]
            articleToAddTabFilter.value=articleToAddTab.value
          
        }else{
            if(theme){
                articleToAddTab.value=[]
                tab.value="two"
                articleToAdd.value= store.state.articles['731'][theme]
                for(let ref in store.state.articles['731'][theme]  ){
                    if(!negoce.value.articles[theme]){
                        articleToAddTab.value.push({code:ref,libelle:store.state.articles['731'][theme][ref][Object.keys(store.state.articles['731'][theme][ref])[0]].designation,theme:store.state.articles['731'][theme][ref][Object.keys(store.state.articles['731'][theme][ref])[0]].code_theme})
                    }else{
                        if(!negoce.value.articles[theme][ref]){
                          articleToAddTab.value.push({code:ref,libelle:store.state.articles['731'][theme][ref][Object.keys(store.state.articles['731'][theme][ref])[0]].designation,theme:store.state.articles['731'][theme][ref][Object.keys(store.state.articles['731'][theme][ref])[0]].code_theme})  
                        }
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            else{   
                // console.log(articleToAddTabFilter.value);             
                articleToAddTab.value=[]
                tab.value="three"
                articleToAdd.value= store.state.articles['731']
                for(let th in store.state.articles['731'] ){
                    if(!negoce.value.articles[th]){
                        articleToAddTab.value.push({code:th,libelle:store.state.articles['731'][th][Object.keys(store.state.articles['731'][th])[0]][Object.keys(store.state.articles['731'][th][Object.keys(store.state.articles['731'][th])[0]])[0]].theme})
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            
        }
    }
        let grapheType=ref()
    let articleToDelete=ref()
    function supprimer(){
        if(articleToDelete.value.type=='color'){
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2]).length>1){
            delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2][articleToDelete.value.art.codebarre];
        }else{
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme]).length>1){
                delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(negoce.value.articles).length>1){
                    delete negoce.value.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        }else{
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme]).length>1){
                delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(negoce.value.articles).length>1){
                    delete negoce.value.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        // console.log(negoce.value.articles);
        
    }
    function totaleQte(params) {
        let qte=0
        for (let el in params){
            qte+=Number(params[el].qte)
        }
        return qte
    }
    function totaleHt(params) {
        let totale=0
        for (let el in params){
            totale+=Number(params[el].qte)*params[el].vte_negoce
        }
        return totale.toFixed(2)
    }
    function totaleQteCde(params) {
        let qte=0
        for(let el in params){
            for (let el1 in params[el]){
                qte+=Number(params[el][el1].qte)
            }
        }
        return qte
    }
    function totaleHtCde(params) {
        let totale=0
        for(let el in params){
            for (let el1 in params[el]){
                totale+=Number(params[el][el1].qte)*params[el][el1].vte_negoce
            }
        }
        return totale.toFixed(2)
    }
    function totaleHtCde2(params) {
        let totale=0
        let qte=0
        for(let el in params){
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    totale+=Number(params[el][el1][el2].qte)*params[el][el1][el2].vte_negoce
                    qte+=params[el][el1][el2].qte
                }
                
            }
        }
        return {
            totale:totale.toFixed(2),
            qte:qte
        }
    }
    function chartData1() {
        const colorPalette = [
            "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
            "#FF9F40", "#E7E9ED", "#FF6B6B", "#6BCB77", "#FFD93D",
            "#845EC2", "#D65DB1", "#FF6F91", "#FF9671", "#FFC75F",
            "#F9F871", "#2C73D2", "#0081CF", "#0089BA", "#008E9B",
            "#008F7A", "#B39CD0", "#FFAAA5", "#FCF6BD", "#D0F4DE",
            "#A9DEF9", "#E4C1F9", "#FFCAD4", "#B5EAD7", "#C7CEEA"
        ];  
        let tab=[]
        let colorTab=[]
        let tabQte=[]
        let i=0
        let qte=0
        let params=negoce.value.articles
        for(let el in params){
            tab.push(params[el][Object.keys(params[el])[0]][Object.keys(params[el][Object.keys(params[el])[0]])[0]].theme)
            
            colorTab.push(colorPalette[i])
            i++
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    qte+=params[el][el1][el2].qte
                } 
            }
            tabQte.push(qte),
            qte=0
        }
        return {tabTheme:tab,colorTab:colorTab,tabQte:tabQte}
    }
    const save = (t) => {
        negoce.value.signature.exist=true
        negoce.value.signature.link=signature1.value.save(t)   
        sendImages()   
        
    }
    
    const clear = () => {
        signature1.value.clear()
    }
    
    const undo = () => {
        signature1.value.undo();
    }
    const handleDisabled = () => {
        state.disabled = !state.disabled
    }
    const isEmpty = () => {
        signature1.value.isEmpty()
    }
    let rechercher=ref()
    let articleToAddTabFilter=ref()
    watch(rechercher,()=>{
        let regex = new RegExp(rechercher.value, "i")
        if(tab.value=='one'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code_couleur}${el.couleur}${el.codebarre}${el.ean13_y2}`).match(regex))
        }else{
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code}${el.libelle}`).match(regex))
        } 
    })
    const exportToExcel = (excelData) => {
    // Définir les champs à exporter avec leurs en-têtes en français
        const fieldsToExport = [
            { key: 'gl_naturepieceg', header: 'Nature Document' },
            { key: 'date_livraison', header: 'Date Livraison' },
            { key: 'numero', header: 'Numéro' },
            { key: 'gp_librepiece3', header: 'Saison' },
            { key: 'etablissement', header: 'Établissement' },
            { key: 'marque', header: 'Marque' },
            { key: 'rayon', header: 'Rayon' },
            { key: 'ga_familleniv3', header: 'Code-Sous-Famille' },
            { key: 'sousfamille', header: 'Sous-Famille' },
            { key: 'theme', header: 'Thème' },
            { key: 'ga_codearticle', header: 'Code Article' },
            { key: 'codefourn', header: 'Réf Fournisseur' },
            { key: 'couleur', header: 'Couleur' },
            { key: 'taille', header: 'Taille' },
            { key: 'codebarre', header: 'Code-barres' },
            { key: 'cab_secondaire', header: 'CAB Secondaire' },
            { key: 'gl_qtestock', header: 'Quantité' },    
            { key: 'gl_puhtnet', header: 'PU HT Net' },
            { key: 'gl_totalht', header: 'TOTAL HT Net' }
        ];

        // Filtrer et formater les données
        const filteredData = excelData.map(item => {
            const row = {};
            fieldsToExport.forEach(field => {
                const value = item[field.key];
                
                // Formater les dates si nécessaire
                if (field.key === 'date_livraison' && value) {
                    // Convertir la date en format lisible
                    const date = new Date(value);
                    if (!isNaN(date.getTime())) {
                        row[field.header] = date.toLocaleDateString('fr-FR');
                    } else {
                        row[field.header] = value;
                    }
                } else if (field.key === 'gl_qtestock' || field.key === 'gl_puhtnet' || field.key ===  'gl_totalht') {
                    // Formater les nombres
                    const numValue = parseFloat(value);
                    row[field.header] = isNaN(numValue) ? 0 : numValue;
                } else {
                    // Valeur textuelle
                    row[field.header] = value !== undefined && value !== null ? value : '';
                }
            });
            return row;
        });

        // Créer la feuille Excel
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        
        // Appliquer les styles aux en-têtes
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "2E75B6" } }, // Bleu
            alignment: { horizontal: "center", vertical: "center" },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
            }
        };

        // Appliquer le style aux en-têtes (première ligne)
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = headerStyle;
            }
        }

        // Ajuster la largeur des colonnes automatiquement
        const colWidths = [];
        for (let C = range.s.c; C <= range.e.c; ++C) {
            let maxLength = 0;
            
            // Vérifier la longueur de l'en-tête
            const headerCell = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[headerCell] && worksheet[headerCell].v) {
                maxLength = Math.max(maxLength, worksheet[headerCell].v.toString().length);
            }
            
            // Vérifier la longueur des données
            for (let R = 1; R <= range.e.r; ++R) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (worksheet[cellAddress] && worksheet[cellAddress].v) {
                    maxLength = Math.max(maxLength, worksheet[cellAddress].v.toString().length);
                }
            }
            
            // Ajouter un peu de marge
            colWidths.push({ wch: Math.min(Math.max(maxLength + 2, 10), 50) });
        }
        worksheet['!cols'] = colWidths;

        // Ajouter un filtre automatique
        worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) };

        // Créer le classeur
        const workbook = XLSX.utils.book_new();
        const sheetName = `Export_Negoces_${getCurrentDateYYYYMMDD()}`;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.substring(0, 31)); // Limite à 31 caractères

        // Exporter le fichier
        const fileName = `negoces_export_${getCurrentDateYYYYMMDD()}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        
        // console.log(`✅ Fichier exporté : ${fileName} avec ${filteredData.length} lignes`);
    };

    // Version simplifiée sans styles avancés
    const exportToExcelSimple = (excelData) => {
        const fieldsToExport = [
            'gl_naturepieceg',
            'date_livraison',
            'numero',
            'gp_librepiece3',
            'etablissement',
            'marque',
            'rayon',
            'ga_familleniv3',
            'sousfamille',
            'theme',
            'ga_codearticle',
            'codefourn',
            'couleur',
            'taille',
            'codebarre',
            'cab_secondaire',
            'gl_qtestock',
            'gl_pmrp'
        ];

        // Filtrer les données
        const filteredData = excelData.map(item => {
            const row = {};
            fieldsToExport.forEach(field => {
                row[field] = item[field] !== undefined ? item[field] : '';
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Export');
        XLSX.writeFile(workbook, `negoces_${getCurrentDateYYYYMMDD()}.xlsx`);
    };

// Fonction pour obtenir la date au format YYYYMMDD
// function getCurrentDateYYYYMMDD() {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}${month}${day}`;
// }
    function getCurrentDateYYYYMMDD() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }
    function getArticles(){
        store.commit('updateWaiting')
        let params=
        {   
            marques:['731'],
            collections:['H25','E25','E24','H24','E26','H26']
        }
        let url=    `https://my.edisac.com/api/articlesdeep`
        let config = {
        method: 'get',
        url: url,
        params:params
        };
        return axios.request(config)
        .then((response) => {
            store.commit('addArticles',response.data.articles) 
            store.commit('updateWaiting')    
        })
        .catch((error) => {
        console.log(error);
        });
        
    }
    
    async  function sendImages(){
       if(negoce.value.signature.exist){
            let data = {
                reception:Math.round(new Date().getTime() / 1000),
                signature:negoce.value.signature.link,
                }
            let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/upload',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
            }
            return axios.request(config)
            .then((response) => { 
                
                negoce.value.signature.file=response.data.signature   
                sendCommandeNegoce()     
            })
            .catch((error) => {
            console.log(error);
            });
       }
        
    }
    let numneg=ref()
    async function getCommandeNegoce (numnegtoget,id,token){
        store.commit('updateWaiting')
        let url=    `https://my.edisac.com/api/negoce`
        let config = {
            method: 'get',
            url: url,
            params:{
                id:id,
                numero:numnegtoget,
                token:token
            }
        };
        return   axios.request(config)
        .then((response) => {
            store.commit('updateWaiting')
            if(response.data.exist){
                negoce.value=response.data
                commandeNotExist.value={exist:true,numero:numnegtoget,new:'old'}
            }else{
                router.replace({ path: '/login' }) 
                commandeNotExist.value={exist:true,numero:numnegtoget,new:'rien'}
            }
        })
        .catch((error) => {
        console.log(error);
        });
    }
    
    async  function sendCommandeNegoce(){
        // await sendImages()
        
        let data = {...negoce.value} 
        if(store.state.user.groupe!='N'){
            data = {...negoce.value,
                token:store.state.user.token
            } 
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/negoce',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        }
      
        return axios.request(config)
        .then((response) => { 
            commandeNotExist.value={exist:true,numero:response.data.numero,new:'new'}
            negoce.value=response.data.donnes
        })
        .catch((error) => {
        console.log(error);
        });
    }
    async  function EnvoyerCommandeNegoce(){
        dialogEmail.value=true
        let data = {...negoce.value,negoce:true}
            
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/resendemail',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        }

        return axios.request(config)
        .then((response) => { 

        })
        .catch((error) => {
        console.log(error);
        });
    }
    function checkingLogIn(){
       
        let data = JSON.stringify({
            "username": store.state.user.username,
            "password": mdpSaisie.value
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/login',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
        .then((response) => {
            // console.log(response.data);
            if(response.data.statut=='connected'){
                sendCommandeNegoce()
                // validerProposition(fabricantToValidate.value)
                authentification.value=false
            }else {
                message.value=`${response.data.name}, le mot de passe n'est pas correcte`
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }
    let statsTableFiltred=ref([])
    async function getStatsTiers(type,tiers){
        filtreSingleParams.value.gp_tiers=tiers
        axe.value={x:'gp_librepiece3',y:'gl_qtestock'};
        // let url = `http://localhost:8282/apimyedisac/statistics/${type}`
        let url = `https://my.edisac.com/api/statistics/${type}`
        let config = {
            method: 'post',
            url: url,
            data:filtreSingleParams.value
        }
        return axios.request(config)
            .then((response) => { 
                if(response.data.statsTable.length>0){
                    statsTable.value=response.data.statsTable
                    statsTableFiltred.value=statsTable.value
                    // console.log(statsTable.value);
                    loading.value=false 
                    dialogueFiltreTiers.value=false
                    readyToExport.value=true
                    dialogStatsTiers.value=true;
                    
                }else{
                    dialogErreur.value=true
                    loading.value=false 

                }
                 
            })
            .catch((error) => {
            console.log(error)
            })
    
    }
    let itemsClient=ref({})
    async function getClients(){   
        let url=    `https://my.edisac.com/api/clients?etablissement=NEGO`
        // console.log(url);
        
        let config = {
        method: 'get',
        url: url
        };
        return   axios.request(config)
        .then((response) => {
            // console.log(response.data);
            
            // store.commit('addClient',response.data) 
            // loading.value=false   
            itemsClient.value={
                clientTable: response.data.map(x=>x=`${x.t_tiers} - ${x.t_prenom}`),
                clients:response.data
            }
            // console.log(itemsClient.value)
            

        })
        .catch((error) => {
        console.log(error);
        });

    }

    onBeforeRouteUpdate((to, from) => {
        loadParams()
    })
    onMounted(()=>{
        getArticles()
        loadParams()
        getClients()
        // console.log(router.currentRoute.value);
        
        
        
    })
    
</script>
<style>
.v-expansion-panel-title{
   height: 10px; 
}
.chart-container {
  width: 600px;    /* Largeur souhaitée */
  height: 100px;   /* Hauteur souhaitée */
  position: relative;
}

.scroll-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 16px;
}
.iconAdd{
cursor: pointer;
}
.iconAdd:hover{
background-color: orange;
}
.entete.sticky {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}

/*  */
.currency-input-container {
  position: relative;
  display: inline-block;
  max-width: 300px;
  width: 100%;
}

.modern-currency-input {
  width: 100%;
  padding: 1px 45px 1px 20px;
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  background-color: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: right;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-currency-input:focus {
  outline: none;
  border-color: #0066ff;
  box-shadow: 0 4px 16px rgba(0, 102, 255, 0.15);
  transform: translateY(-1px);
}

.modern-currency-input:hover {
  border-color: #b3c7d9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.modern-currency-input::placeholder {
  color: #9aa6b8;
  font-weight: 400;
}

.currency-symbol {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600;
  color: #66758a;
  font-size: 18px;
  pointer-events: none;
  transition: color 0.3s ease;
}

.modern-currency-input:focus + .currency-symbol {
  color: #0066ff;
}

/* États de validation */
.modern-currency-input:valid {
  border-color: #00c853;
}

.modern-currency-input:invalid:not(:placeholder-shown) {
  border-color: #ff4444;
}
.actions-card {
  margin-top: 20px;
}
.chart-container {
  width: 900px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-pie {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-bar {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
/*  */
</style>